import React, { useEffect, useState } from 'react';
import { getPosts, getCategories, getRedes } from '../api';
import PostCard, { PostModal } from '../components/PostCard';

export default function Home({ settings }) {
  const [posts, setPosts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [redes, setRedes] = useState([]);
  const [activeCategory, setActiveCategory] = useState('all');
  const [selectedPost, setSelectedPost] = useState(null);

  useEffect(() => {
    getPosts().then(data => {
      setPosts(data);
      // Check if ?post=ID is in URL on load
      const params = new URLSearchParams(window.location.search);
      const postId = params.get('post');
      if (postId) {
        const found = data.find(p => String(p.id) === String(postId));
        if (found) setSelectedPost(found);
      }
    }).catch(() => {});

    getCategories().then(setCategories).catch(() => {});
    getRedes().then(setRedes).catch(() => {});
  }, []);

  const handleOpenPost = (post) => {
    setSelectedPost(post);
    // Update URL query param without reloading page
    const params = new URLSearchParams(window.location.search);
    params.set('post', post.id);
    const newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?${params.toString()}`;
    window.history.pushState({ path: newUrl }, '', newUrl);
  };

  const handleClosePost = () => {
    setSelectedPost(null);
    // Remove query param from URL without reloading page
    const params = new URLSearchParams(window.location.search);
    params.delete('post');
    const searchString = params.toString();
    const queryPart = searchString ? `?${searchString}` : '';
    const newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}${queryPart}`;
    window.history.pushState({ path: newUrl }, '', newUrl);
  };

  const filteredPosts = activeCategory === 'all'
    ? posts
    : posts.filter(p => String(p.category_id) === String(activeCategory));

  return (
    <>
      {/* Profile Header */}
      <div className="profile-header">
        <div className="profile-info">
          <h1><span>{settings.site_title}</span></h1>
          <div className="profile-stats">
            <div><strong>{posts.length}</strong><span>publicaciones</span></div>
          </div>
          <div className="profile-bio">
            {settings.site_bio}
          </div>
          {redes.length > 0 && (
            <div className="profile-urls">
              {redes.map(r => (
                <a key={r.id} href={r.link_url} target="_blank" rel="noopener noreferrer" className="profile-url-item">
                  <img src={r.logo_url} alt={r.name} />
                  {r.name && <span>{r.name}</span>}
                </a>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Tabs */}
      <div className="feed-tabs" style={{ flexWrap: 'wrap' }}>
        <button className={activeCategory === 'all' ? 'active' : ''} onClick={() => setActiveCategory('all')}>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" style={{ marginRight: 2 }}>
            <rect x="2" y="2" width="9" height="9"/><rect x="13" y="2" width="9" height="9"/>
            <rect x="2" y="13" width="9" height="9"/><rect x="13" y="13" width="9" height="9"/>
          </svg>
          TODAS
        </button>
        {categories.map(c => (
          <button key={c.id} className={String(activeCategory) === String(c.id) ? 'active' : ''} onClick={() => setActiveCategory(c.id)}>
            {c.name.toUpperCase()}
          </button>
        ))}
      </div>

      {/* Grid */}
      {filteredPosts.length === 0 ? (
        <div className="empty-state">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/>
            <polyline points="21 15 16 10 5 21"/>
          </svg>
          <p>No hay publicaciones en esta categoría</p>
        </div>
      ) : (
        <div className="feed-grid">
          {filteredPosts.map(p => (
            <PostCard key={p.id} post={p} settings={settings} onOpen={() => handleOpenPost(p)} />
          ))}
        </div>
      )}

      {selectedPost && (
        <PostModal post={selectedPost} onClose={handleClosePost} settings={settings} />
      )}
    </>
  );
}
